import { Icons } from '@commenda/kakashi';
import { cn } from '@commenda/utils';

import { CommandItem } from '../ui/command';
import type { IComposerPickerOption } from './composer-picker-menu-helper';

interface ComposerPickerMenuOptionProps {
  option: IComposerPickerOption;
  isSelected: boolean;
  onSelect: (value: string) => void;
}

/** One row of a composer picker menu: a title, an optional grey second line, and a checkmark on the
 * current value. */
export const ComposerPickerMenuOption = ({
  option,
  isSelected,
  onSelect,
}: ComposerPickerMenuOptionProps) => (
  <CommandItem
    value={`${option.label} ${option.description ?? ''}`}
    onSelect={() => onSelect(option.value)}
    className={cn(
      'mx-sm cursor-pointer items-start gap-lg rounded-sm px-md py-md data-[selected=true]:bg-bg-secondary data-[selected=true]:text-text-primary',
      isSelected && 'bg-bg-secondary'
    )}
  >
    <span className="flex min-w-0 flex-1 flex-col">
      <span className="truncate txt-small-medium text-text-primary">
        {option.label}
      </span>
      {option.description && (
        <span className="truncate txt-extra-small-regular text-text-tertiary">
          {option.description}
        </span>
      )}
    </span>
    <span className="w-4 shrink-0">
      {isSelected && <Icons.Check aria-hidden="true" className="size-4" />}
    </span>
  </CommandItem>
);
